import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const FinalCTA = ({ onConsultationClick }) => {
  return (
    <section className="py-10 sm:py-20 bg-[#21242C] border-t border-gray-700 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#FFD000] rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#C8E347] rounded-full filter blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-8 lg:px-12 text-center relative z-10">
        <h2 className="text-xl sm:text-4xl lg:text-6xl font-normal text-white mb-3 sm:mb-6 leading-tight" style={{ fontFamily: "'DM Serif Display', serif" }}>
          If Your Last Hire Did Not Meet Expectations
        </h2>
        <p className="text-base sm:text-2xl text-gray-300 mb-5 sm:mb-10">
          Correct the screening process before the next one.
        </p>

        <Button 
          onClick={onConsultationClick}
          size="lg"
          className="bg-[#FFD000] hover:bg-[#FFD000]/90 text-black font-semibold px-6 sm:px-12 py-4 sm:py-8 text-sm sm:text-xl transition-all duration-300 hover:scale-105"
        >
          Request a Confidential Consultation
          <ArrowRight className="ml-2 sm:ml-3 h-4 w-4 sm:h-6 sm:w-6" />
        </Button>

        <p className="text-gray-400 mt-4 sm:mt-8 text-xs sm:text-base">
          Structured engagement. Founder-level accountability. Operational stability.
        </p>

        {/* What Happens Next Section */}
        <div className="mt-8 sm:mt-16 pt-6 sm:pt-12 border-t border-gray-700">
          <h3 className="text-base sm:text-xl font-semibold text-white mb-4 sm:mb-6">
            What Happens Next
          </h3>
          <p className="text-gray-400 text-xs sm:text-sm mb-3 sm:mb-4">After you submit:</p>
          <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-8 text-left sm:text-center">
            <div className="flex items-center sm:flex-col sm:items-center gap-2 sm:gap-3">
              <span className="bg-[#FFD000] text-black font-bold rounded-full w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center text-xs sm:text-sm flex-shrink-0">1</span>
              <p className="text-gray-300 text-xs sm:text-sm">We review your operational needs</p>
            </div>
            <div className="flex items-center sm:flex-col sm:items-center gap-2 sm:gap-3">
              <span className="bg-[#FFD000] text-black font-bold rounded-full w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center text-xs sm:text-sm flex-shrink-0">2</span>
              <p className="text-gray-300 text-xs sm:text-sm">We assess hiring risk areas</p>
            </div>
            <div className="flex items-center sm:flex-col sm:items-center gap-2 sm:gap-3">
              <span className="bg-[#FFD000] text-black font-bold rounded-full w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center text-xs sm:text-sm flex-shrink-0">3</span>
              <p className="text-gray-300 text-xs sm:text-sm">We confirm if we can assist</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
